import { LAYERS } from './FileArchSection1Claude';
import { BACKEND_GROUPS } from './FileArchSection2Backend';
import { FRONTEND_GROUPS } from './FileArchSection2Frontend';
import { DOCS_GROUPS } from './FileArchSection3Docs';
import FileArchSection1Claude from './FileArchSection1Claude';
import FileArchSection2Backend from './FileArchSection2Backend';
import FileArchSection2Frontend from './FileArchSection2Frontend';
import FileArchSection3Docs from './FileArchSection3Docs';
import { C, Badge } from './shared';

const SectionHeader = ({ label, sub, color, count }) => (
  <div style={{ background:C.card, borderRadius:10, padding:'14px 20px',
    borderTop:'4px solid '+color, border:'1px solid '+color+'44', marginTop:8 }}>
    <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
      <div>
        <div style={{ color:color, fontWeight:800, fontSize:14 }}>{label}</div>
        <div style={{ color:C.muted, fontSize:11, marginTop:2 }}>{sub}</div>
      </div>
      {count && <Badge color={color}>{count} files</Badge>}
    </div>
  </div>
);

const DeployBanner = ({ label, sub, color }) => (
  <div style={{ background:C.card, borderRadius:8, padding:'8px 16px',
    border:'1px solid '+color+'44' }}>
    <div style={{ color:color, fontWeight:700, fontSize:11 }}>{label}</div>
    <div style={{ color:C.muted, fontSize:10 }}>{sub}</div>
  </div>
);

export default function FileArchTab() {
  // Compute counts dynamically — never hardcode file counts in this shell
  const claudeFileCount   = LAYERS.reduce((sum, l) => sum + l.files.length, 0);
  const backendFileCount  = BACKEND_GROUPS.reduce((sum, g) => sum + g.files.length, 0);
  const frontendFileCount = FRONTEND_GROUPS.reduce((sum, g) => sum + g.files.length, 0);
  const docsFileCount     = DOCS_GROUPS.reduce((sum, g) => sum + g.files.length, 0);
  const productFileCount  = backendFileCount + frontendFileCount;

  return (
    <div style={{ display:'grid', gap:12 }}>

      {/* MASTER HEADER — counts driven from section arrays, never hardcoded */}
      <div style={{ background:C.card, borderRadius:10, padding:16,
        borderTop:'4px solid '+C.info, border:'1px solid '+C.info+'44' }}>
        <div style={{ color:C.info, fontWeight:800, fontSize:14, marginBottom:4 }}>
          Canonical File Map — Full Product + Claude Project
        </div>
        <div style={{ color:C.muted, fontSize:12 }}>
          3 sections · {claudeFileCount} Claude project + tooling files · ~{productFileCount} product source files · {docsFileCount} reference doc entries.
          Section 1: how we build. Section 2: what deploys. Section 3: reference.
          ⚡ D3 markers = signal chain dependency — breaking these affects the live trading engine.
          Reference: .claude/CLAUDE_ALIGNMENT_PROTOCOL.md Part 4
        </div>
      </div>

      {/* SECTION 1 */}
      <SectionHeader
        label="Section 1 — Claude Project Map"
        sub="Development intelligence — session protocol, gates, architecture decisions, roadmap, build scripts. Does not deploy."
        color={C.green} count={claudeFileCount}
      />
      <FileArchSection1Claude />

      {/* SECTION 2 */}
      <SectionHeader
        label="Section 2 — Product Source Files"
        sub="Everything that deploys. If these files break, the product is down."
        color='#f97316' count={productFileCount}
      />
      <DeployBanner
        label="OCI VM-1 PRIMARY (Backend) — api.marketpulze.com ✅"
        sub="backend/ folder deploys here. GitHub Actions: push main → VM-1 (1m 25s). Dev branch → dev VM (dev.api.marketpulze.com)."
        color='#f97316'
      />
      <FileArchSection2Backend />
      <DeployBanner
        label="CLOUDFLARE PAGES (Frontend + Public)"
        sub="src/ + public/ + root config. Global CDN. CI=true npm run build. Warnings treated as errors."
        color={C.info}
      />
      <FileArchSection2Frontend />

      {/* SECTION 3 */}
      <SectionHeader
        label="Section 3 — Reference Documentation"
        sub="docs/ folder. Not deployed. Update at Phase C before team scale-up."
        color={C.muted} count={docsFileCount}
      />
      <FileArchSection3Docs />

    </div>
  );
}
